<template>
  <div class="recommond-wrap" v-if="list && list.length">
    <div class="header" v-if="isTitle">为您推荐</div>
    <div class="recommond-items">
      <swiper class="swiper-x-container" ref="recSwiper" :options="swiperOpts">
        <swiper-slide class="swiper-x-item" v-for="(item, index) in list" :key="index">
          <BaseItem :source="item" :enableFavorite="true"  @hideSearchLayer="hideSearchLayer" :key="index" />
        </swiper-slide>
        <!-- <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
        <div class="swiper-button-next swiper-button-white" slot="button-next"></div> -->
      </swiper>
      <SwiperNavBtns v-if="innerWidth > 1024" :xSwiper="recSwiper" :direction="direction" mode="sides" />
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import BaseItem from "@/components/BaseItem.vue";
import SwiperNavBtns from "@/components/SwiperNavBtns.vue";
import types from "@/store/types";
import api from "@/utils/api";

let $vm = null

export default {
  components: { swiper, swiperSlide, SwiperNavBtns, BaseItem },
  props: {
    region: {
      type: String,
      validator(value) {
        return ["pdp_rec", "cart_rec", "empty_order_rec", "account_rec"].indexOf(value) != -1;
      }
    },
    gid: {
      type: [Number, String],
      required: false
    },
    isTitle: {
      type: Boolean,
      value: true
    }
  },
  data() {
    return {
      recSwiper: {},
      swiperOpts: {
        loop: true,
        speed: 1000,
        slidesPerView: 3,
        spaceBetween: 16,
        navigation: {
          prevEl: '.carousel__btn--prev',
          nextEl: '.carousel__btn--next'
        },
        on: {
          slidePrevTransitionStart() {
            $vm.direction = "prev";
          },
          slidePrevTransitionEnd() {
            $vm.direction = "";
          },
          slideNextTransitionStart() {
            $vm.direction = "next";
          },
          slideNextTransitionEnd() {
            $vm.direction = "";
          }
        },
        breakpoints: {
          768: {
            slidesPerView: 1.95,
            centeredSlides: true,
            centeredSlidesBounds: true,
            spaceBetween: 16
          }
        }
      },
      direction: "",
      list: []
    }
  },
  created() {
    $vm = this;
    this.loadSource();
  },
  methods: {
    loadSource() {
      let newArgs = { flag: this.region };
      if (this.region == 'pdp_rec') {
        this.gid ? (newArgs.id = this.gid) : console.info("相关推荐缺少主商品ID");
      }
      api[types.RECOMMEND_LIST](newArgs).then(res => {
        if (res.code == 1) {
          this.list = res.data.list;
          this.$nextTick(() => {
            this.recSwiper = this.$refs?.recSwiper?.swiper;
          });
        } else {
          this.$toast({ message: res.message, iconCls: "failure" });
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    hideSearchLayer() {
      this.$emit('hideSearchLayer')
    },
  },
  computed: {
    innerWidth() {
      return window.innerWidth;
    }
  }
}
</script>

<style lang="scss" scoped>
  .recommond-wrap {
    .header { font-size: 16px; color: #282828; text-align: center; padding: 1.25rem 0; }
    .recommond-items {
      box-sizing: border-box; width: 100%; display: flex; flex-wrap: wrap; position: relative;
      & /deep/ .sides-mode {
        .carousel__btn--prev { left: 1.5625rem; }
        .carousel__btn--next { right: 1.5625rem; }
      }
    }
  }
  @media only screen and (min-width: 48rem) {
    .recommond-wrap {
      .header { font-size: 0.875rem; font-weight: 700; text-align: left; }
    }
  }
</style>